import React from "react";
import DetalleCard from "~business/Cards/DetalleCard";
import { useDispatch, useSelector } from "react-redux";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import UsuariosSelector from "./UsuariosSelector";
import ItemInputCard from "~business/Cards/ItemInputCard";

import ItemSelectorCard from "~business/Cards/ItemSelectorCard";

import { FieldChangeEvent } from "~business/Cards/types";
import {
  CampoFormulario,
  RamaOption,
  RamaSeleccionada,
  UsuarioSeleccionado,
} from "../../types";

import {
  companiasSegurosOptions,
  companiasFilter,
} from "../constants/companias";

import {
  setRama,
  setUsuario,
  setCompania,
  setCobertura,
  clearUsuario,
  setSubmitting,
} from "../actions";

interface SliceDatosGenerales {
  rama: RamaSeleccionada;
  compania: CampoFormulario<string>;
  ramasFilter: RamaOption[] | null;
  ramasOptions: Record<string, string>;
  usuario: UsuarioSeleccionado;
  cobertura: CampoFormulario<string | null>;
  isLoadingUsuarios: boolean;
}

interface DatosGeneralesCardProps {
  isLoading: boolean;
}

const useReduxSelector = () =>
  useSelector<any, SliceDatosGenerales>((state) => ({
    rama: state.altaPolizaMultiramaReducer.ramaSelected,
    compania: state.altaPolizaMultiramaReducer.companiaSelected,
    ramasFilter: state.altaPolizaMultiramaReducer.ramasFilter,
    ramasOptions: state.altaPolizaMultiramaReducer.ramasOptions,
    usuario: state.altaPolizaMultiramaReducer.usuarioSelected,
    cobertura: state.altaPolizaMultiramaReducer.coberturaSelected,
    isLoadingUsuarios: state.altaPolizaMultiramaReducer.isLoadingUsuarios,
  }));

const title = "Datos Generales";

const DatosGeneralesCard: React.FC<DatosGeneralesCardProps> = ({
  isLoading,
}) => {
  const dispatch = useDispatch();

  const {
    rama,
    ramasFilter,
    ramasOptions,
    usuario,
    compania,
    cobertura,
    isLoadingUsuarios,
  } = useReduxSelector();

  let timer: ReturnType<typeof setTimeout> | undefined;

  const handleChangeRama = (rama: CampoFormulario<string>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setRama(rama));
    }, 200);
  };

  const handleChangeCompania = (compania: CampoFormulario<string>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setCompania(compania));
    }, 200);
  };

  const handleChangeCobertura = (
    cobertura: FieldChangeEvent<string | null>
  ) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setCobertura(cobertura));
    }, 200);
  };

  const handleChangeUsuario = (event: {
    target: { value: UsuarioSeleccionado };
  }) => {
    dispatch(setUsuario({ ...event.target.value, selected: true }));
  };

  const handleClearUsuario = () => {
    dispatch(clearUsuario());
  };

  const handleBlur = () => {
    dispatch(setSubmitting(false));
  };

  return (
    <>
      <DetalleCard title={title} IconHeader={VerifiedUserIcon}>
        <ItemSelectorCard<string>
          id={"rama"}
          isLoading={isLoading}
          label={"Rama"}
          onChange={handleChangeRama}
          value={rama.value}
          options={ramasFilter!}
          valueOptions={ramasOptions}
          variant="big"
          required
        />

        <ItemSelectorCard<string>
          id={"compania"}
          isLoading={isLoading}
          label={"Compañía"}
          onChange={handleChangeCompania}
          value={compania.value}
          options={companiasFilter}
          valueOptions={companiasSegurosOptions}
          variant="big"
          required
        />

        <UsuariosSelector
          isLoading={isLoadingUsuarios}
          value={usuario}
          onChange={handleChangeUsuario}
          onClear={handleClearUsuario}
        />
        <ItemInputCard
          id={"cobertura"}
          isLoading={isLoading}
          label={"Cobertura"}
          value={cobertura.value}
          onChange={handleChangeCobertura}
          onBlur={handleBlur}
          focus={cobertura.focus}
          required
        />
      </DetalleCard>
    </>
  );
};

export default DatosGeneralesCard;
